const preLoadedImages = [];

/**
 * Will preload all images in order to avoid flickering
 */
export default async function preloadImages() {
  return new Promise(async (resolve) => {
    // just in case we call this function several times (please don't), let's reset the array
    preLoadedImages.length = 0;

    // https://webpack.js.org/guides/dependency-management/#require-context
    // eslint-disable-next-line no-undef
    const requireImages = require.context(
      // Look for files in the img directory
      "./img/",
      // Look in subdirectories
      true,
      // Only include images files
      /\.(png|jpg|gif)$/,
    );

    await Promise.all(
      requireImages.keys().map(async (filePath) => {
        // remove the initial "./" from the filePath
        const imgPath = filePath.replace(/^\.\//, "");
        // we want to create and load the image in order to stay in the cache
        const image = await imageLoaded(imgPath);
        // we want to keep an array of this because of the following:
        // https://stackoverflow.com/questions/20762053/javascript-preloading-images-keeping-storing-variables-in-scope-or-not
        // tl;dr: the garbage collector might dispose the preloaded images if the app is running for a long time
        // by storing them in a variable, we avoid that
        preLoadedImages.push(image);
      }),
    );

    resolve();
  });
}

async function imageLoaded(imgName) {
  return new Promise((resolve) => {
    // in order to preload we have to create an image and set its src manually
    const image = new Image();
    // jest can't handle template litteral require(`@etab/assets/img/${imgName}`) because of a weird bug only affecting jest --watch
    // https://stackoverflow.com/questions/56112953/jest-could-not-locate-module-with-dynamic-import-template-string
    // https://github.com/facebook/jest/issues/7511
    image.setAttribute("src", require("@etab/assets/img/" + imgName)); // eslint-disable-line
    // once the image is loaded, we proceed
    image.addEventListener("load", () => resolve(image));
  });
}
